/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';
import { Constants } from '../../../core/constants';
import { Mousetrap } from '../../common';

import './RootInteractiveLayer.scss';

const RootInteractiveLayer: FunctionComponent = (): JSX.Element => {
    return (
        <Mousetrap className={'root-interactive-layer'} value={Constants.ROOT_INTERACTIVE_LAYER}>
            {}
        </Mousetrap>
    );
};

export default RootInteractiveLayer;
